export default "__VITE_ASSET__bNav4HxC__"